<template>
  <div class="tab-bar">
    <TabBarIcon v-for="({ icon, routeName }, i) in tabs" :key="`tab-bar-icon-${i}`" :icon="icon" :routeName="routeName" />
  </div>
</template>

<script>
  import TabBarIcon from '@/components/TabBarIcon.vue';

  export default {
    name: 'tab-bar',
    components: {
      TabBarIcon,
    },
    props: {
      tabs: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/mixins.scss';

  .tab-bar {
    height: 12.5vh;
    box-sizing: border-box;
    z-index: 1000;

    background-color: var(--color-background);

    @include drop-shadow();

    display: flex;
    justify-content: space-around;
    align-items: center;
  }
</style>
